export const ARUniEntryRequestStatus = {
  DRAFT: "DRFT",
  SUBMITTED: "SUB",
  ACCEPTED: "ACC",
  REJECTED: "REJ",
};

export const ARUniEntryRequestRecognizedEduLevel = {
  DENIED: "DEN",
};

export const ARNacidStatus = {
  WEAKENED: "WEAK",
  DENIED: "DEN",
  ACKNOWLEDGED: "ACK",
};

export const ARUniversityStatus = {
  ACKNOWLEDGED: "ACK",
};
